import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AppProps = {
    contactMinRecaptcha: number;
    uploadMinRecaptcha: number;
    choixDebutTravaux: string[];
};

export interface ParametreState {
    app: AppProps;
}

const initialState: ParametreState = {
    app: {} as unknown as AppProps
};

export const parametreSlice = createSlice({
    name: 'parametres',
    initialState,
    reducers: {
        updateApp(state, action: PayloadAction<Partial<AppProps>>) {
            state.app = { ...state.app, ...action.payload };
        }
    }
});
